<template>
  <IndexBase 
    @auth="onAuth($event)"
    action="Index"
    controller="Shipment"
  ></IndexBase>

<Card>
    <template #title>
      <Toolbar>
        <template #left>
          <div class="p-card-title">
            {{ $t("shipment") }}

            <Button icon="pi pi-refresh" class="p-button-rounded p-button-info p-button-outlined mr-2" @click="loadLazyData"/>
          </div>
        </template>

        <template #right>
          <Realization
            :data="selectedRow"
            v-if="dataModel != null && canViewRealization && canView"
            @close="onModalClose"
            @message="sidebarMessage($event)"
          />
          <History
            :data="selectedRow"
            v-if="dataModel != null && canViewHistory && canView"
            @close="onModalClose"
            @message="sidebarMessage($event)"
          />
          <CancelShipment
            :data="selectedRow"
            v-if="dataModel != null && canCancelShipment && canEdit"
            @close="onModalClose"
            @message="sidebarMessage($event)"
          />
          <EditShipment
            :data="selectedRow"
            v-if="dataModel != null && canEditShipment && canEdit"
            @close="onModalClose"
            @message="sidebarMessage($event)"
          />

          <Withdraw
            :data="selectedRow"
            v-if="dataModel != null && canWithdrawShipment && canEdit && isUser"
            @close="onModalClose"
            @message="sidebarMessage($event)"
          />

          <POD
            :data="selectedRow"
            v-if="dataModel != null && ((canPOD && canCreate) || (canViewPOD && canView))"
            :canPOD="canPOD"
            :canViewPOD="canViewPOD"
            @close="onModalClose"
            @message="sidebarMessage($event)"
          />
          <Appointment
            :data="selectedRow"
            v-if="
              dataModel != null && (canCreateAppointment || canEditAppointment) && canCreate
            "
            :type="canCreateAppointment ? 'create' : 'edit'"
            @close="onModalClose"
            @message="sidebarMessage($event)"
          />
          <QR
            :data="selectedRow"
            v-if="dataModel != null && canGenerateQR && canView"
            @close="onModalClose"
          />
          <ShipmentTracking :data="selectedRow" v-if="dataModel!=null && canViewTracking && canView" />

          <ConvertShipment :data="selectedRow" v-if="dataModel!=null && canConvert && canView" @close="onModalClose" />
        </template>
      </Toolbar>
    </template>
    <template #content>
      <div class="p-fluid mb-3">
        <CustomSelectButton
          v-model="selectedStatus"
          :options="statusList"
          optionLabel="option"
          class="p-text-center"
          @change="onChangeStatus"
        >
          <template #option="slotProps">
            <div class="p-text-center" style="width: 100%">
              <b>{{ slotProps.option }}</b>
            </div>
          </template>
        </CustomSelectButton>
      </div>

      <!--:scrollable="true"
            scrollDirection="both"-->
      <DataTable
        ref="dt"
        responsiveLayout="scroll"
        class="p-datatable-sm"
        filterDisplay="row"
        sortMode="multiple"
        removableSort
        v-model:expandedRows="expandedRows"
        stateStorage="local"
        :stateKey="stateKey"
        :value="dataModel"
        :loading="!dataModel || loading"
        :paginator="true"
        :rows="15"
        :lazy="true"
        v-model:first="this.start"
        scrollHeight="70vh"
        wrapperClass="responsive-height"
        @rowExpand="onRowExpand"
        @state-restore="onStateRestore($event)"
        @page="onPage($event)"
        @sort="onSort($event)"
        @filter="onFilter($event)"
        @update:selection="onSelect($event)"
        v-model:filters="filters"
        :totalRecords="totalRecords"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        v-model:selection="selectedRow"
        selectionMode="single"
        dataKey="Id"
        :metaKeySelection="false"
      >
        <template #empty> No records found </template>
        <Column
          :exportable="false"
          :sortable="false"
          :expander="true"
          headerStyle="width: 1rem"
        >
          <template #filter>
            <Button
              :label="$t('clear')"
              icon="pi pi-filter-slash"
              class="p-button-outlined p-button-primary p-button-sm"
              @click="clearFilter"
              :badge="filterBadge"
              badgeClass="p-badge-danger"
            />
          </template>
          <template #body="slotProps">
            <i
              class="pi pi-lock"
              style="color: red"
              v-if="slotProps.data.Lock_WB"
            />
            <i class="pi pi-lock-open" style="color: green" v-else />
          </template>
        </Column>
         <Column
          field="Shipment_No"
          :header="$t('shipment_no')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('shipment_no')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column field="Order_No" :header="$t('order_no')" :sortable="true">
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('order_no')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          field="Loading_Destination_From_Name"
          :header="$t('loading')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('loading')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          field="Loading_Destination_To_Name"
          :header="$t('destination')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('destination')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          field="Transporter_Name"
          :header="$t('transporter')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('transporter')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column field="Driver_Name" :header="$t('driver')" :sortable="true">
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('driver')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          field="Vehicle_Name"
          :header="$t('vehicle_no')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('vehicle_no')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column field="SAP_No" :header="$t('sap_no')" :sortable="true">
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('sap_no')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column field="Status" :header="$t('status')" :sortable="true">
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('status')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
              :disabled="true"
            />
          </template>
        </Column>
        <Column
          field="Progress_Status"
          :header="$t('progress_status')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <!-- <InputText type="text" :placeholder="$t('progress_status')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  /> -->
            <CustomDropdown
              v-if="filterModel"
              v-model="filterModel.value"
              :options="progressStatusList"
              :placeholder="$t('progress_status')"
              class="p-column-filter p-inputtext-sm"
              @change="filterCallback()"
            >
            </CustomDropdown>
          </template>
        </Column>
        <Column
          field="Stuffing_Date_From"
          :header="$t('stuffing_date')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('stuffing_date')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
          <template #body="{ data }">
            {{
              $formatDate(data.Stuffing_Date_From) +
              " - " +
              $formatDate(data.Stuffing_Date_To)
            }}
          </template>
        </Column>
        <Column
          field="Appointment_Status"
          :header="$t('appointment_status')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <!-- <InputText type="text" :placeholder="$t('appointment_status')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  /> -->
            <CustomDropdown
              v-if="filterModel"
              v-model="filterModel.value"
              :options="appointmentStatusList"
              :placeholder="$t('appointment_status')"
              class="p-column-filter p-inputtext-sm"
              @change="filterCallback()"
            >
            </CustomDropdown>
          </template>
        </Column>
        <Column
          field="Appointment_Date"
          :header="$t('appointment_date')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('appointment_date')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
          <template #body="{ data }">
            {{ $formatDate(data.Appointment_Date) }}
          </template>
        </Column>
        <Column
          field="Appointment_Time"
          :header="$t('appointment_time')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('appointment_time')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          field="Appointment_Status_Date"
          :header="$t('appointment_status_date')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('appointment_status_date')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
           <template #body="{ data }">
            {{ $formatDateTime(data.Appointment_Status_Date) }}
          </template>
        </Column>
        <Column
          field="Delivery_Address"
          :header="$t('address')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('address')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          field="Truck_Type_Name"
          :header="$t('truck_type')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('truck_type')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          field="Appointment_Status_Remarks"
          :header="$t('appointment_status_remarks')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('appointment_status_remarks')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
       
        <Column
          field="shipment_type_name"
          :header="$t('shipment_type')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <CustomDropdown
              v-if="filterModel"
              v-model="filterModel.value"
              :options="shipmentTypeList"
              :placeholder="$t('shipment_type')"
              class="p-column-filter p-inputtext-sm"
              @change="filterCallback()"
            >
            </CustomDropdown>
          </template>
        </Column>
        <Column
          field="incoterm_name"
          :header="$t('incoterm_name')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('incoterm_name')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          field="distribution"
          :header="$t('distribution')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('distribution')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column field="document_type" :header="$t('doc_type')" :sortable="true">
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('doc_type')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          field="Product_Category"
          :header="$t('product_category')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('product_category')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        
        <Column
          field="has_tracking"
          :header="$t('has_tracking')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <YNSelect :placeholder="$t('has_shipment')" :useBinary="false" v-if="filterModel" v-model="filterModel.value" @change="filterCallback()"/>
          </template>
          <template #body="{data}">
              {{ data.has_tracking ? "Y" : "N"}}
          </template>
        </Column>
        <Column field="POD_Date" :header="$t('pod_date')" :sortable="true">
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('pod_date')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
          <template #body="{ data }">
            {{ $formatDate(data.POD_Date) }}
          </template>
        </Column>
        <Column field="Lock_WB" :header="$t('lock_wb')" :sortable="true">
          <template #filter="{ filterModel, filterCallback }">
            <YNSelect
              :placeholder="$t('lock_wb')"
              :useBinary="true"
              v-if="filterModel"
              v-model="filterModel.value"
              @change="filterCallback()"
            />
          </template>
          <template #body="{ data }">
            {{ this.$formatBoolean(data.Lock_WB) }}
          </template>
        </Column>
        <Column
          field="Completed_Date"
          :header="$t('completed_date')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('completed_date')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          field="Created_Date"
          :header="$t('created_date')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <!-- <InputText type="text" :placeholder="$t('created_date')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  /> -->
            <DatePicker
              dateFormat="dd/mm/yyyy"
              inputMask="99/99/9999"
              momentFormat="DD/MM/YYYY"
              class="p-column-filter p-inputtext-sm"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              :placeholder="$t('created_date')"
            />
          </template>
          <template #body="{ data }">
            {{ this.$formatDateTime(data.Created_Date) }}
          </template>
        </Column>
        <Column field="Created_By" :header="$t('created_by')" :sortable="true">
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('created_by')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          field="Edited_Date"
          :header="$t('edited_date')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <!-- <InputText type="text" :placeholder="$t('created_date')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  /> -->
            <DatePicker
              dateFormat="dd/mm/yyyy"
              inputMask="99/99/9999"
              momentFormat="DD/MM/YYYY"
              class="p-column-filter p-inputtext-sm"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              :placeholder="$t('edited_date')"
            />
          </template>
          <template #body="{ data }">
            {{ this.$formatDateTime(data.Edited_Date) }}
          </template>
        </Column>
        <Column field="Edited_By" :header="$t('edited_by')" :sortable="true">
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('edited_by')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <template #expansion="slotProps">
          <div class="shipments-subtable">
            <DataTable :value="slotProps.data.Details" class="w-screen-70">
              <Column field="Item_No" :header="$t('item_no')"></Column>
              <Column
                field="Material_Name"
                :header="$t('material_name')"
                class="w-8"
              ></Column>
              <Column field="Qty" :header="$t('qty')">
                 <template #body="{ data }">
                  {{ $formatNumber(data.Qty) }}
                </template>
              </Column>
              <Column field="os_qty" :header="$t('os_qty')">
                <template #body="{ data }">
                  {{ $formatNumber(data.os_qty) }}
                </template>
              </Column>
              <Column field="Real_Qty" :header="$t('real_qty')">
                <template #body="{ data }">
                  {{ $formatNumber(data.Real_Qty) }}
                </template>
              </Column>
              <Column field="UOM" :header="$t('uom')"></Column>
            </DataTable>

            <DataTable :value="slotProps.data.Drivers" class="w-screen-50 mt-1">
              <Column field="Driver_Name" :header="$t('driver')"></Column>
              <Column field="License_No" :header="$t('license_no')"></Column>
              <Column field="Phone" :header="$t('phone')"></Column>
              <Column field="Vehicle_Name" :header="$t('vehicle_no')"></Column>
              <Column field="Container_No" :header="$t('container_no')"></Column>
            </DataTable>
          </div>
        </template>
      </DataTable>
    </template>
  </Card>
</template>

<script>
import IndexBase from "../Helper/IndexBase.vue";
import Appointment from "./_Appointment.vue";
import Realization from "./_Realization.vue";
import History from "./_History.vue";
import CancelShipment from "./_CancelShipment.vue";
import EditShipment from "./_EditShipment.vue";
import POD from "./_POD.vue";
import QR from "./_QR.vue";
import ShipmentTracking from "./_Tracking.vue";
import ConvertShipment from "./_ConvertShipment.vue";
import Withdraw from './_Withdraw.vue';

export default {
  name: "Shipment",
  components: {
    IndexBase: IndexBase,
    Appointment: Appointment,
    Realization: Realization,
    History: History,
    CancelShipment: CancelShipment,
    EditShipment: EditShipment,
    POD: POD,
    QR: QR,
    ShipmentTracking: ShipmentTracking,
    ConvertShipment: ConvertShipment,
    Withdraw: Withdraw
  },
  data() {
    return {
      dataModel: null,
      loading: false,
      totalRecords: 0,
      start: 0,
      stateKey: "itm-state-shipment-" + this.$store.getters.getUsername,
      role: this.$store.getters.getRole,
      isAdmin: this.$store.getters.getIsAdmin,
      isUser: this.$store.getters.getIsUser,
      isTransporter: this.$store.getters.getIsTransporter,
      isDriver: this.$store.getters.getIsDriver,
      sorts: null,
      lazyParams: {},
      filters: null,
      stateFilters: null,
      editorPath: "/Shipment/Editor",
      dataUrl: "shipment/list",
      masterListUrl: "shipment/master_list",
      canCreate: false,
      canEdit: false,
      canDelete: false,
      canView: false,
      selectedRow: null,

      selectedStatus: null,
      expandedRows: [],

      statusList: null,
      progressStatusList: null,
      appointmentStatusList: null,
      shipmentTypeList: null,
    };
  },
  methods: {
    onAuth(event) {
      this.canCreate = event.canCreate;
      this.canEdit = event.canEdit;
      this.canDelete = event.canDelete;
      this.canView = event.canView;
    },
    onPage(event) {
      this.start = event.first;
      this.loadLazyData();
    },
    onSort(event) {
      this.sorts = event.multiSortMeta;
      this.loadLazyData();
    },
    onFilter() {
      this.loadLazyData();
    },
    onSelect(event) {
      this.selectedRow = event;
    },
    onRowExpand(event) {
      this.expandedRows = [];
      this.expandedRows.push(event.data);
    },
    editor(mode, id) {
      this.$router.push({
        path: this.editorPath,
        query: { mode: mode, id: id },
      });
    },
    loadLazyData() {
      this.selectedRow = null;

      this.lazyParams = {
        start: this.start,
        sorts: this.dataSort,
        filters: this.dataFilter,
      };

      var self = this;

      if(!self.loading){
        self.loading = true;

        this.$axios
          .post(this.$API_URL + this.dataUrl, this.lazyParams)
          .then((response) => {
            if (response.data.success) {
              self.dataModel = response.data.data;
              self.totalRecords = response.data.totalRecords;
            } else {
              self.$toast.add({
                severity: "error",
                summary: "Error",
                detail: response.data.message,
                life: 120000,
              });
            }

            self.loading = false;
          })
          .catch(function (err) {
            self.$toast.add({
              severity: "error",
              summary: "Error",
              detail: err.message,
              life: 120000,
            });
            self.loading = false;
          });
      }

     
    },
    setFilters() {
      this.filters = {};
      var exportable = this.$refs.dt.columns.filter((c) => c.props.field);
      for (var i = 0; i < exportable.length; i++) {
        var filterValue = "";
        var fieldName = exportable[i].props.field;
        if (this.stateFilters) {
          var field = this.stateFilters[fieldName];
          if (field) filterValue = field.value ? field.value : null;
          else filterValue = null;
        }
        this.filters[fieldName] = { value: filterValue, matchMode: "contains" };

        if (fieldName == "Status") {
          if (filterValue) this.selectedStatus = filterValue;
          else this.selectedStatus = "All";
        }
      }
    },
    onStateRestore(event) {
      this.start = event.first;
      this.stateFilters = event.filters;
      this.sorts = event.multiSortMeta;
    },
    onModalClose() {
      this.loadLazyData();
    },
    clearFilter() {
      this.filters = {};
      var exportable = this.$refs.dt.columns.filter((c) => c.props.field);
      for (var i = 0; i < exportable.length; i++) {
        var fieldName = exportable[i].props.field;
        var filterValue = "";

        if (fieldName == "Status") {
          filterValue = this.selectedStatus;
        } else if (fieldName.includes("Date")) {
          filterValue = null;
        }

        this.filters[exportable[i].props.field] = {
          value: filterValue,
          matchMode: "contains",
        };
      }

      this.sorts = [];

      this.loadLazyData();
    },
    onChangeStatus(event) {
      var status = event.value;

      this.filters.Status.value = status;

      this.$toast.removeAllGroups();
      this.loadLazyData();
    },
  },
  mounted() {
    this.$emit("unblock-ui");
    this.setFilters();
    this.loadLazyData();
    this.$showToast();

    var self = this;

    this.$axios
      .get(this.$API_URL + this.masterListUrl)
      .then((response) => {
        if (response.data.success) {
          self.statusList = response.data.data.status;
          self.progressStatusList = response.data.data.progress_status;
          self.appointmentStatusList = response.data.data.appointment_status;
          self.shipmentTypeList = response.data.data.shipment_type;
        } else {
          self.$toast.add({
            severity: "error",
            summary: "Error",
            detail: response.data.message,
            life: 120000,
          });
        }

        self.loading = false;
      })
      .catch(function (err) {
        self.$toast.add({
          severity: "error",
          summary: "Error",
          detail: err.message,
          life: 120000,
        });
        self.loading = false;
      });
  },
  computed: {
    filterBadge() {
      var badgeNumber = 0;

      this.dataFilter.filter(function (item) {
        if (item.value && item.field != "Status") {
          badgeNumber++;
        }
      });

      return badgeNumber;
    },
    dataFilter() {
      var h = [];
      if (this.filters) {
        for (const [key, value] of Object.entries(this.filters)) {
          h.push({
            field: key ? key : null,
            value: value.value,
            matchMode: value.matchMode,
          });
        }
      }
      return h;
    },
    dataSort() {
      var h = [];
      if (this.sorts) {
        for (var x = 0; x < this.sorts.length; x++) {
          h.push({
            field: this.sorts[x].field,
            order: this.sorts[x].order == 1 ? "ASC" : "DESC",
          });
        }
      }
      return h;
    },
    canEditShipment() {
      var data = this.selectedRow;
      if (data) {
        return data.can_edit_shipment;
      }
      return false;
    },
    canCreateAppointment() {
      var data = this.selectedRow;
      if (data) {
        return data.can_create_appointment;
      }
      return false;
    },
    canEditAppointment() {
      var data = this.selectedRow;
      if (data) {
        return data.can_edit_appointment;
      }
      return false;
    },
    canCancelShipment() {
      var data = this.selectedRow;
      if (data) {
        return data.can_cancel_shipment;
      }
      return false;
    },
    canPOD() {
      var data = this.selectedRow;
      if (data) {
        return data.can_pod;
      }
      return false;
    },
    canViewPOD() {
      var data = this.selectedRow;
      if (data != null) {
        return data.can_view_pod;
      }
      return false;
    },
    canViewRealization() {
      var data = this.selectedRow;
      if (data) {
        return true;
      }
      return false;
    },
    canViewHistory() {
      var data = this.selectedRow;
      if (data) {
        return true;
      }
      return false;
    },
    canViewTracking(){
        var data = this.selectedRow
        if(data){
            return data.can_view_tracking
        }
        return false
    },
    canGenerateQR() {
      var data = this.selectedRow;
      if (data) {
        return true;
      }
      return false;
    },
    canConvert(){
      var data = this.selectedRow;
      if(data){
        return data.can_convert_shipment;
      }
      return false;
    },
    canWithdrawShipment(){
      var data = this.selectedRow;
      if(data){
        return data.can_withdraw_shipment;
      }
      return false;
    }
  },
};
</script>

<style #scoped>
.p-card .p-card-content {
  margin: 0 !important;
  padding: 0 !important;
}
</style>
